/* unplugin-vue-components disabled */import script from "./ThirdPartyBatchEnableModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThirdPartyBatchEnableModal.vue?vue&type=script&setup=true&lang=ts"

import "./ThirdPartyBatchEnableModal.vue?vue&type=style&index=0&id=1adb5526&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1adb5526"]])

export default __exports__